<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import Cache from '@services/Cache';
import apiClient from '@services/ApiClient';

export default {
    name: 'DeliveryGroupFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];

            if (Cache.get('delivery-groups')) {
                options = Cache.get('delivery-groups');
            } else {
                await apiClient.get('/vue/cardseries/delivery_groups')
                    .then((response) => {
                        options = response.data.map((item) => ({
                            id: item.delivery_group,
                            label: item.delivery_group_name,
                        }));
                        Cache.set('delivery-groups', options);
                    });
            }

            return options;
        },
    },
};
</script>
